import { Col, Grid, Row } from "react-bootstrap";
import React from "react";

export const ModalContentWrapper = ({ children }) => (
  <Grid fluid>
    <Row>
      <Col xs={10} xsOffset={1}>
        {children}
      </Col>
    </Row>
  </Grid>
);
